<template>
  <div align="Left">
    <md-card id="screenings" align="Left">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">visibility</i>
        </div>
        <h4 class="title">Available Screenings</h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-left" style="padding: 0">
          <div class="md-layout md-gutter md-layout-item"
            :class="{ 'md-size-20': !screeningsProp, 'md-size-40': !!screeningsProp }">
            <md-field class="md-sm">
              <label>Search</label>
              <md-input v-model="searchTxt" @keyup.enter="handleSearch" />
            </md-field>
          </div>

          <div class="md-layout-item md-size-20" v-if="!screeningsProp && organizations.length > 2">
            <md-field>
              <label for="currentType">Organization</label>
              <md-select v-model="currentOrganization" name="organization">
                <md-option v-for="(type, index) in organizations" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item" style="align-items: end;" :class="[
            { 'md-size-60': organizations.length > 2 },
            { 'md-size-80': organizations.length <= 2 }
          ]">
            <div class="md-layout md-gutter md-layout-item"
              style="display: flex; align-items: center; justify-content: right">
              <md-button class="md-icon-button md-primary" @click="handleSearch">
                <md-icon>search</md-icon>
                <md-tooltip md-direction="bottom">Filter screenings</md-tooltip>
              </md-button>
              <md-button class="md-icon-button md-primary" @click="handleRefresh">
                <md-icon>refresh</md-icon>
                <md-tooltip md-direction="bottom">Refresh list</md-tooltip>
              </md-button>
            </div>
          </div>
        </div>
      </md-card-header>

      <md-card-content style="padding-top: 0px" v-if="!isLoading">
        <md-table v-model="tableData" class="table-shopping table-striped table-hover" @md-selected="getSelected"
          @click.native="labelSort($event, false)">
          <md-table-row>
            <md-table-empty-state :md-description="`No screenings found for this time frame or search criteria`"
              md-label="No screenings found" />
          </md-table-row>
          <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single" @click="gotoEval(item)">
            <md-table-cell></md-table-cell>

            <md-table-cell md-label="date"
              style="margin-top: 9px; margin-bottom: 9px; padding-top: 9px; padding-bottom: 9px">
              <span style="font-weight: 500"><b>{{ item.Date.split("T")[0].replace(/-/g, "/") }}</b></span>
              <br />
              <small class="change-color" style="color: darkgreen">
                {{ item.packageID.slice(0, 11).toUpperCase() }}
              </small>
            </md-table-cell>

            <md-table-cell md-label="name">
              <span v-if="item.firstName" style="font-size: 0.97rem; font-weight: 500">{{ item.firstName }} {{
                item.lastName }}</span>
              <br v-if="item.firstName" />
              <small class="change-color" v-if="item.Email" style="font-size: 0.8rem; color: blue">{{
                item.Email
              }}</small>
              <span v-if="!item.firstName && !item.Email">-</span>
              <!-- <span>{{ item.firstName }}</span> <br /> -->
              <!-- <small style="font-size: .80rem; color: darkgray; "> {{ item.Email }} </small> -->
            </md-table-cell>

            <!-- <md-table-cell v-if="FL" md-label="name" style="color: #0000f3; font-size: 1.05rem;"> {{ item.firstName}} <br
              <small style="font-size: .80rem; color:darkgray;"> {{ item.Email }} </small>
            </md-table-cell> -->
            <!-- <md-table-cell v-else md-label="name">{{item.lastName }} <br>
              <small style="font-size: .80rem; color:darkgray;"> {{ item.Email }} </small>
            </md-table-cell> -->

            <md-table-cell md-label="gender">{{ item.Gender || '-' }}</md-table-cell>
            <md-table-cell md-label="Globe">{{ item.Device || '-' }}</md-table-cell>
            <md-table-cell md-label="city">{{ item.city || '-' }}</md-table-cell>
            <md-table-cell md-label="technician">{{ item.Technician || '-' }}</md-table-cell>
            <md-table-cell md-label="start">
              {{ item.Date.slice(-8, -3)
              }}<!--<small>{{ item.start }}</small>-->
            </md-table-cell>
            <md-table-cell md-label="duration"> {{ item.Duration }} &nbsp; min </md-table-cell>

            <md-table-cell />
          </md-table-row>
        </md-table>

        <div class="table table-stats">
          <div class="text-right">
            <hr />
            <div class>
              <p class="card-category text-center" style="margin-top: 8px">
                Showing &nbsp;<b><u>{{ total }}</u></b>&nbsp; Screening{{ tableData.length === 1 ? "" : "s" }}
              </p>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>

    <loader :is-visible="isLoading" />
  </div>
</template>
<script>
import swal from "sweetalert2"
import moment from "moment"
import loader from "@/components/GlobeChek/loader.vue"

export default {
  components: {
    loader
  },
  props: {
    screeningsProp: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      isLoading: false,
      screenings: [],
      payload: {
        kioskID: "0-000",
        hold: false,
        filter: "m12" // d-day, m-month, w-week, y-year, a-all
      },
      selectedFilter: 4,
      filterItems: [
        { id: 1, val: "d", name: "Day", disp: "screens in the past Day" },
        { id: 2, val: "w", name: "Week", disp: "screens in the past Week" },
        { id: 3, val: "m", name: "Month", disp: "screens in the past Month" },
        { id: 4, val: "m3", name: "3-Months", disp: "screens in the past 3-Months" },
        { id: 5, val: "m6", name: "6-Months", disp: "screens in the past 6-Months" },
        { id: 6, val: "y", name: "Year", disp: "screens in the past Year" },
        { id: 7, val: null, name: "All", disp: "screens in Total" }
      ],
      searchTxt: "",
      tableData: [],
      currentOrganization: JSON.parse(sessionStorage.getItem("organizations")).length === 1 ? JSON.parse(sessionStorage.getItem("organizations"))[0].orgId : (localStorage.getItem("currentOrgSelectedForFilters") || "all"),
      organizations: [
        { label: 'All', value: 'all' },
        ...JSON.parse(sessionStorage.getItem('organizations')).map(i => {
          return {
            label: i.orgName,
            value: i.orgId
          }
        }),
      ],
    }
  },
  watch: {
    screeningsProp: {
      handler(newScreenings) {
        if (Array.isArray(newScreenings)) {
          this.tableData = newScreenings
        }
      },
      immediate: true
    },
  },
  mounted() {
    if (Array.isArray(this.screeningsProp)) {
      this.tableData = this.screeningsProp
    } else {
      this.fetchScreenings()
    }
  },
  computed: {
    total() {
      if (Array.isArray(this.tableData)) {
        return this.tableData.length
      }
      return 0
    }
  },
  methods: {
    handleSearch() {
      const self = this;
      let response = this.screenings.slice(0);
      localStorage.setItem("currentOrgSelectedForFilters", self.currentOrganization)
      if (self.currentOrganization != 'all' && !this.screeningsProp) {
        response = response.filter(i => i.orgID === self.currentOrganization);
      }
      if (self.searchTxt) {
        response = response.filter((a) => {
          // Convert null values to '' so toLowerCase() will work on compare
          a.firstName = a.firstName ? a.firstName : ""
          a.lastName = a.lastName ? a.lastName : ""
          a.packageID = a.packageID ? a.packageID : ""
          a.Email = a.Email ? a.Email : ""
          a.Gender = a.Gender ? a.Gender : ""
          a.Technician = a.Technician ? a.Technician : ""
          a.Device = a.Device ? a.Device : ""
          a.city = a.city ? a.city : ""
          a.Date = a.Date ? a.Date : ""

          return (
            a.firstName.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.lastName.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.packageID.slice(0, 11).includes(self.searchTxt.toLowerCase()) ||
            a.Email.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Gender.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Technician.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Device.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.city.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Date.slice(-8, -3).includes(self.searchTxt.toLowerCase())
          )
        })
      }
      this.tableData = response
    },
    handleRefresh() {
      this.fetchScreenings()
    },
    async fetchScreenings() {
      try {
        this.isLoading = true;
        const response = await window.axios.get(`${process.env.VUE_APP_URL}/screenings/m0/${sessionStorage.getItem("userID")}`)
        this.screenings = response.data;
        this.handleSearch();
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    },
    labelSort(type, menu) {
      let sort = menu ? type : event.target.textContent.trim()
      this.sortBy = sort

      if (sort == this.sortBy) {
        this.orderAsc = !this.orderAsc
      } else {
        this.orderAsc = true
      }

      switch (sort.toLowerCase()) {
        case "name":
          this.screensByLastfirst(this.orderAsc)
          break

        case "date":
          this.screensByDateTime(this.orderAsc)
          break

        case "technician":
          this.screensByTechnician(this.orderAsc)
          break

        case "globe":
          this.screensByGlobe(this.orderAsc)
          break

        case "city":
          this.screensByCity(this.orderAsc)
          break

        case "gender":
          this.screensByGender(this.orderAsc)
          break

        default:
          return null
      }
    },
    screensByLastfirst(order) {
      let newScreenings = this.screenings.slice().sort(function (a, b) {
        if (order) {
          return a.lastName > b.lastName ? 1 : -1
        } else {
          return a.lastName < b.lastName ? 1 : -1
        }
      })
      this.tableData = newScreenings;
    },
    screensByDateTime(order) {
      let newScreenings = this.screenings.slice().sort(function (a, b) {
        if (order) {
          return new moment(a.Date).format("YYYYMMDD") > new moment(b.Date).format("YYYYMMDD") ? 1 : -1
        } else {
          return new moment(a.Date).format("YYYYMMDD") < new moment(b.Date).format("YYYYMMDD") ? 1 : -1
        }
      })
      this.tableData = newScreenings;
    },
    screensByTechnician(order) {
      let newScreenings = this.screenings.slice().sort(function (a, b) {
        if (order) {
          return a.Technician.toLowerCase() > b.Technician.toLowerCase() ? 1 : -1
        } else {
          return a.Technician.toLowerCase() < b.Technician.toLowerCase() ? 1 : -1
        }
      })
      this.tableData = newScreenings;
    },
    screensByGlobe(order) {
      let newScreenings = this.screenings.slice().sort(function (a, b) {
        if (order) {
          return a.Device > b.Device ? 1 : -1
        } else {
          return a.Device < b.Device ? 1 : -1
        }
      })
      this.tableData = newScreenings;
    },
    screensByCity(order) {
      let newScreenings = this.screenings.slice().sort(function (a, b) {
        if (order) {
          return a.city.toLowerCase() > b.city.toLowerCase() ? 1 : -1
        } else {
          return a.city.toLowerCase() < b.city.toLowerCase() ? 1 : -1
        }
      })
      this.tableData = newScreenings;
    },
    screensByGender(order) {
      let newScreenings = this.screenings.slice().sort(function (a, b) {
        if (order) {
          return a.Gender > b.Gender ? 1 : -1
        } else {
          return a.Gender < b.Gender ? 1 : -1
        }
      })
      this.tableData = newScreenings;
    },
    getSelected(item) {
      this.selected = item
    },

    gotoEval(item) {
      this.selected = item
      sessionStorage.setItem("screeningID", item.packageID)
      sessionStorage.setItem("storageID", item.screenID)
      sessionStorage.setItem("OrgID", item.orgID)
      sessionStorage.setItem("OrgCode", item.orgCode)
      sessionStorage.setItem("OrgBusiness", item.orgBusiness)
      sessionStorage.setItem("patientUserID", item.patientUserID)
      this.$store.dispatch("updateScreeningStatus", item.status)

      const payload = {
        FN: item.firstName.split(" ")[0],
        LN: item.firstName.split(" ")[1],
        EM: item.Email
      }
      console.log("PROVENANCE Payload: ", payload)
      this.$store.dispatch("loadMedicalHistory", payload)

      var ongoingScreenings = JSON.parse(localStorage.getItem("ongoingScreenings"))
      if (!ongoingScreenings) {
        ongoingScreenings = [item.packageID]
      } else if (!ongoingScreenings.includes(item.packageID)) {
        ongoingScreenings.push(item.packageID)
      }
      localStorage.setItem("ongoingScreenings", JSON.stringify(ongoingScreenings))
      let fdr = {
        External: {
          findingsOS: [],
          findingsOD: [],
          diagnosesOS: [],
          diagnosesOD: [],
          recommendOS: [],
          recommendOD: []
        },
        Corneal: {
          findingsOS: [],
          findingsOD: [],
          diagnosesOS: [],
          diagnosesOD: [],
          recommendOS: [],
          recommendOD: []
        },
        Nerve: {
          findingsOS: [],
          findingsOD: [],
          diagnosesOS: [],
          diagnosesOD: [],
          recommendOS: [],
          recommendOD: []
        },
        Lens: {
          findingsOS: [],
          findingsOD: [],
          diagnosesOS: [],
          diagnosesOD: [],
          recommendOS: [],
          recommendOD: []
        },
        Fundus: {
          findingsOS: [],
          findingsOD: [],
          diagnosesOS: [],
          diagnosesOD: [],
          recommendOS: [],
          recommendOD: []
        },
        Anterior: {
          findingsOS: [],
          findingsOD: [],
          diagnosesOS: [],
          diagnosesOD: [],
          recommendOS: [],
          recommendOD: []
        },
        Macular: {
          findingsOS: [],
          findingsOD: [],
          diagnosesOS: [],
          diagnosesOD: [],
          recommendOS: [],
          recommendOD: []
        }
      }
      localStorage.setItem(item.packageID, JSON.stringify(fdr))

      //load Images for selected Eval then goto Eval page
      //this.$store.dispatch("loadImages", sessionStorage.getItem("storageID"));
      // this.$router.push(`${sessionStorage.getItem('portalRoute')}/evaluation`)
      window.location.href = `${sessionStorage.getItem('portalRoute')}/evaluation`
    },
  }
}
</script>

<style lang="scss" scoped>
#referral {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.md-table {
  max-height: 67dvh;
  overflow: auto;
}

.md-table-cell {
  padding: 2px 8px;
  font-size: 14px;
}

.text-right ::v-deep .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}

.md-table ::v-deep .md-table-head:last-child {
  text-align: right;
}

.table-shopping {
  table>thead>tr>th {
    text-transform: uppercase;
  }

  table>thead>tr>.md-table-head .md-table-head-label {
    font-size: 0.75rem;

    b {
      display: block;
      margin-bottom: 3px;
    }
  }

  .td-name {
    font-size: 1em !important;
    line-height: 1.1;

    small {
      color: green;
      font-size: 0.77em;
    }
  }

  .td-name {
    min-width: 200px;
  }

  .td-number {
    text-align: right;
    min-width: 150px;

    small {
      margin-right: 3px;
    }
  }

  .img-container {
    width: 120px;
    max-height: 160px;
    overflow: hidden;
    display: block;

    img {
      width: 100%;
    }
  }
}

.md-table-row:hover {
  background-color: #74b5ff !important;
  color: white;
}

.table-striped {
  tbody>tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody>tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.table-selected {
  color: white;
  background-color: #005ac2 !important;

  a,
  small {
    color: white;
  }
}

.mmodal-container {
  max-width: 70vw;
  max-height: 75vh !important;
  overflow: auto;

  margin: 0px auto;
  position: relative;
  background-color: #fff;
  transition: all 0.3s ease;
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  border: none;
  z-index: 9999;
}

.selected-filter-item {
  color: #0041b3;
  font-weight: 500;
}

.md-table {
  cursor: pointer;
}

.dropdown {
  cursor: pointer;
}

.dropdown-menu {
  li {
    padding: 3px 3px 3px 5px;
  }

  li:hover {
    background-color: #005ac2 !important;
    color: #fff !important;
  }
}
</style>
